import { Type, type Static } from '@sinclair/typebox';
import { FIELD_LIMITS } from '../constants.js';
import { RowVersionField, SoftDeleteFields, TimestampFields, UuidSchema } from './common.js';

export const IncotermSchema = Type.Object({
  id: UuidSchema,
  code: Type.String({ minLength: 1, maxLength: FIELD_LIMITS.INCOTERM_CODE_MAX }),
  label: Type.Union([
    Type.String({ maxLength: FIELD_LIMITS.INCOTERM_LABEL_MAX }),
    Type.Null(),
  ]),
  notes: Type.Union([Type.String({ maxLength: FIELD_LIMITS.NOTES_MAX }), Type.Null()]),
  isActive: Type.Boolean(),
  ...TimestampFields,
  ...SoftDeleteFields,
  ...RowVersionField,
});
export type Incoterm = Static<typeof IncotermSchema>;

export const IncotermCreateSchema = Type.Object({
  code: Type.String({ minLength: 1, maxLength: FIELD_LIMITS.INCOTERM_CODE_MAX }),
  label: Type.Optional(Type.String({ maxLength: FIELD_LIMITS.INCOTERM_LABEL_MAX })),
  notes: Type.Optional(Type.String({ maxLength: FIELD_LIMITS.NOTES_MAX })),
});
export type IncotermCreate = Static<typeof IncotermCreateSchema>;

export const IncotermUpdateSchema = Type.Object({
  code: Type.Optional(Type.String({ minLength: 1, maxLength: FIELD_LIMITS.INCOTERM_CODE_MAX })),
  label: Type.Optional(
    Type.Union([Type.String({ maxLength: FIELD_LIMITS.INCOTERM_LABEL_MAX }), Type.Null()]),
  ),
  notes: Type.Optional(
    Type.Union([Type.String({ maxLength: FIELD_LIMITS.NOTES_MAX }), Type.Null()]),
  ),
  isActive: Type.Optional(Type.Boolean()),
  rowVersion: Type.Integer({ minimum: 0 }),
});
export type IncotermUpdate = Static<typeof IncotermUpdateSchema>;
